import { testimonials } from "@/mocks/home";

export default function TestimonialsSection() {
  const leftColumn = testimonials.filter((_, i) => i % 3 === 0);
  const middleColumn = testimonials.filter((_, i) => i % 3 === 1);
  const rightColumn = testimonials.filter((_, i) => i % 3 === 2);

  return (
    <section
      id="testimonials"
      className="relative bg-background-100 py-20 md:py-28"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/2 -translate-y-1/2 -left-32 w-[400px] h-[400px] rounded-full bg-accent-100/20 blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-[300px] h-[300px] rounded-full bg-primary-100/15 blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center max-w-[680px] mx-auto mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 text-accent-800 text-xs uppercase tracking-wider font-semibold mb-6">
            Patient stories
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            Real people. Real stories.
            <br />
            <span className="italic font-serif text-primary-600">
              Free intake, paperwork handled,{" "}
            </span>
            <br />
            walking comfortably again
          </h2>
          <p className="mt-5 text-[15px] md:text-base text-foreground-500 leading-relaxed max-w-[540px] mx-auto">
            These are real stories from people who used QuickProsthetics to
            handle the admin — insurance, financing, care team coordination —
            all for free. Some found new prosthetists, others kept the ones they
            loved. Either way, they're walking comfortably now.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {[leftColumn, middleColumn, rightColumn].map((column, colIndex) => (
            <div key={colIndex} className="flex flex-col gap-5">
              {column.map((t) => (
                <div
                  key={t.id}
                  className="bg-background-50 border border-background-200/70 rounded-2xl p-6 hover:border-accent-200 transition-all duration-300"
                >
                  <div className="mb-4 text-accent-400">
                    <span className="w-8 h-8 flex items-center justify-center">
                      <i className="ri-double-quotes-l text-2xl"></i>
                    </span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                    {t.content}
                  </p>
                  <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-100">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <h4 className="font-heading text-sm font-semibold text-foreground-950">
                        {t.name}
                      </h4>
                      <p className="text-xs text-foreground-500">
                        {t.username}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
